import '@mantine/core/styles.css'
import '@mantine/charts/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/schedule/styles.css'

import 'dayjs/locale/lv'
import { QueryClientProvider, QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { MantineProvider } from '@mantine/core'
import { DatesProvider } from '@mantine/dates'
import { Notifications } from '@mantine/notifications'
import { router } from '@/app/router'
import { SessionProvider } from '@/app/session/SessionProvider'
import { consoleCssVariablesResolver, consoleTheme } from '@/app/styles/theme'
import { createConsoleQueryClient } from '@/shared/lib/query/createQueryClient'

const queryClient = createConsoleQueryClient()

export function App() {
  const { i18n } = useTranslation()

  return (
    <MantineProvider
      theme={consoleTheme}
      cssVariablesResolver={consoleCssVariablesResolver}
      defaultColorScheme="light"
    >
      <DatesProvider settings={{ locale: i18n.language }}>
        <Notifications position="bottom-center" />
        <QueryClientProvider client={queryClient}>
          <QueryErrorResetBoundary>
            <SessionProvider>
              <RouterProvider router={router} />
            </SessionProvider>
          </QueryErrorResetBoundary>
        </QueryClientProvider>
      </DatesProvider>
    </MantineProvider>
  )
}
